import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InitialState, LoginResponse } from "./types";
import { loginAction } from "./action";
import {
  addToLocalStorage,
  addToSessionStorage,
} from "../../../utils/browserStorage";

const initialState: InitialState = {
  loading: false,
  currentOrganisationAccount: null,
  errorMessage: false,
  accessToken: null,
  message: null,
};

const authenticationSlices = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //LoginAction
    builder.addCase(loginAction.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(
      loginAction.fulfilled,
      (state, action: PayloadAction<LoginResponse>) => {
        const { payload } = action.payload;
        addToSessionStorage("accessToken", payload?.accessToken);
        addToSessionStorage("organisationId", payload?.account?.organisationId);
        state.errorMessage = false;
        state.currentOrganisationAccount = payload?.account;
        state.accessToken = payload?.accessToken;
        state.loading = false;
      }
    );
    builder.addCase(loginAction.rejected, (state, action) => {
      state.loading = false;
      state.currentOrganisationAccount = null;
      state.accessToken = null;
      state.errorMessage = true;
    });
  },
});

export default authenticationSlices.reducer;
